import {
  CreatePlatformProjectRequest,
  UpdateProjectPlatformRequest,
} from '@activepieces/ee-shared';
import {
  CreateOrRenameProjectRequest,
  ListProjectRequestForUserQueryParams,
  ProjectWithLimits,
  SeekPage,
} from '@activepieces/shared';

import { api } from '@/lib/api';
import { authenticationSession } from '@/lib/authentication-session';

export const projectApi = {
  current: async () => {
    return projectApi.get(authenticationSession.getProjectId()!);
  },
  list(request: ListProjectRequestForUserQueryParams) {
    return api.get<SeekPage<ProjectWithLimits>>('/v1/users/projects', request);
  },
  get: (projectId: string) => {
    return api.get<ProjectWithLimits>(`/v1/users/projects/${projectId}`);
  },
  update: (projectId: string, request: UpdateProjectPlatformRequest) => {
    return api.post<ProjectWithLimits>(`/v1/projects/${projectId}`, request);
  },
  create: (request: CreatePlatformProjectRequest) => {
    return api.post<ProjectWithLimits>('/v1/projects', request);
  },
  createUserProject: (request: CreateOrRenameProjectRequest) => {
    return api.post<ProjectWithLimits>('/v1/users/projects', request);
  },
  delete: (projectId: string) => {
    return api.delete<void>(`/v1/projects/${projectId}`);
  },
};
